/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-has-content */
import PropTypes from 'prop-types';
import React from 'react';

const NavigationDots = ({ active }) => (
  <div className="app__navigation">
    {['home', 'about', 'works', 'skills', 'testimonials', 'contact'].map(
      (item, index) => (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        <a
          href={`#${item}`}
          key={item + index}
          className="app__navigation-dot"
          style={active === item ? { backgroundColor: '#313BA32' } : {}}
        />
      ),
    )}
  </div>
);

export default NavigationDots;

NavigationDots.propTypes = {
  active: PropTypes.string.isRequired,
};
